function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.172 1.172A4 4 0 0110.874 3H19.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-8.626A3.981 3.981 0 019.83 6.825v.001l-.005.005A4 4 0 013.125 5H.5a.5.5 0 01-.5-.5v-1A.5.5 0 01.5 3h2.626c.173-.67.521-1.304 1.046-1.828zm4.242 1.414a2 2 0 10-.002 2.83l.004-.003a2 2 0 00-.002-2.827zm1.758 8.586A4 4 0 0116.874 13H19.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.626a3.982 3.982 0 01-1.042 1.825l-.001.001-.005.005A4 4 0 019.125 15H.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h8.626c.173-.67.521-1.304 1.046-1.828zm4.242 1.414a2 2 0 10-.002 2.83l.004-.003a2 2 0 00-.002-2.827z",
  fill: "currentColor"
})));